function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tablekeyboard
 */
import TableSelection from './tableselection';
import TableWalker from './tablewalker';
import { Plugin } from 'ckeditor5/src/core';
import { getLocalizedArrowKeyCodeDirection } from 'ckeditor5/src/utils';
import { getSelectedTableCells, getTableCellsContainingSelection } from './utils/selection';
/**
 * This plugin enables keyboard navigation for tables.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableKeyboard = /*#__PURE__*/function (_Plugin) {
  _inherits(TableKeyboard, _Plugin);

  var _super = _createSuper(TableKeyboard);

  function TableKeyboard() {
    _classCallCheck(this, TableKeyboard);

    return _super.apply(this, arguments);
  }

  _createClass(TableKeyboard, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var view = this.editor.editing.view;
      var viewDocument = view.document; // Handle Tab key navigation.

      this.editor.keystrokes.set('Tab', function () {
        return _this._handleTabOnSelectedTable.apply(_this, arguments);
      }, {
        priority: 'low'
      });
      this.editor.keystrokes.set('Tab', this._getTabHandler(true), {
        priority: 'low'
      });
      this.editor.keystrokes.set('Shift+Tab', this._getTabHandler(false), {
        priority: 'low'
      });
      this.listenTo(viewDocument, 'arrowKey', function () {
        return _this._onArrowKey.apply(_this, arguments);
      }, {
        context: 'table'
      });
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:keydown keydown} events for the <kbd>Tab</kbd> key executed
     * when the table widget is selected.
     *
     * @private
     * @param {module:engine/view/observer/keyobserver~KeyEventData} data Key event data.
     * @param {Function} cancel The stop/stopPropagation/preventDefault function.
     */

  }, {
    key: "_handleTabOnSelectedTable",
    value: function _handleTabOnSelectedTable(data, cancel) {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var selectedElement = selection.getSelectedElement();

      if (!selectedElement || !selectedElement.is('element', 'table')) {
        return;
      }

      cancel();
      editor.model.change(function (writer) {
        writer.setSelection(writer.createRangeIn(selectedElement.getChild(0).getChild(0)));
      });
    }
    /**
     * Returns a handler for {@link module:engine/view/document~Document#event:keydown keydown} events for the <kbd>Tab</kbd> key executed
     * inside table cells.
     *
     * @private
     * @param {Boolean} isForward Whether this handler will move the selection to the next or the previous cell.
     */

  }, {
    key: "_getTabHandler",
    value: function _getTabHandler(isForward) {
      var _this2 = this;

      var editor = this.editor;
      return function (domEventData, cancel) {
        var selection = editor.model.document.selection;
        var tableCell = getTableCellsContainingSelection(selection)[0];

        if (!tableCell) {
          tableCell = _this2.editor.plugins.get('TableSelection').getFocusCell();
        }

        if (!tableCell) {
          return;
        }

        cancel();
        var tableRow = tableCell.parent;
        var table = tableRow.parent;
        var currentRowIndex = table.getChildIndex(tableRow);
        var currentCellIndex = tableRow.getChildIndex(tableCell);
        var isFirstCellInRow = currentCellIndex === 0;

        if (!isForward && isFirstCellInRow && currentRowIndex === 0) {
          // Set the selection over the whole table if the selection was in the first table cell.
          editor.model.change(function (writer) {
            writer.setSelection(writer.createRangeOn(table));
          });
          return;
        }

        var tableUtils = _this2.editor.plugins.get('TableUtils');

        var isLastCellInRow = currentCellIndex === tableRow.childCount - 1;
        var isLastRow = currentRowIndex === tableUtils.getRows(table) - 1;

        if (isForward && isLastRow && isLastCellInRow) {
          editor.execute('insertTableRowBelow'); // Check if the command actually added a row. If `insertTableRowBelow` execution didn't add a row (because it was disabled
          // or it got overwritten) set the selection over the whole table to mirror the first cell case.

          if (currentRowIndex === tableUtils.getRows(table) - 1) {
            editor.model.change(function (writer) {
              writer.setSelection(writer.createRangeOn(table));
            });
            return;
          }
        }

        var cellToFocus; // Move to the first cell in the next row.

        if (isForward && isLastCellInRow) {
          var nextRow = table.getChild(currentRowIndex + 1);
          cellToFocus = nextRow.getChild(0);
        } // Move to the last cell in the previous row.
        else if (!isForward && isFirstCellInRow) {
            var previousRow = table.getChild(currentRowIndex - 1);
            cellToFocus = previousRow.getChild(previousRow.childCount - 1);
          } // Move to the next/previous cell.
          else {
              cellToFocus = tableRow.getChild(currentCellIndex + (isForward ? 1 : -1));
            }

        editor.model.change(function (writer) {
          writer.setSelection(writer.createRangeIn(cellToFocus));
        });
      };
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:keydown keydown} events.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_onArrowKey",
    value: function _onArrowKey(eventInfo, domEventData) {
      var editor = this.editor;
      var keyCode = domEventData.keyCode;
      var direction = getLocalizedArrowKeyCodeDirection(keyCode, editor.locale.contentLanguageDirection);

      var wasHandled = this._handleArrowKeys(direction, domEventData.shiftKey);

      if (wasHandled) {
        domEventData.preventDefault();
        domEventData.stopPropagation();
        eventInfo.stop();
      }
    }
    /**
     * Handles arrow keys to move the selection around the table.
     *
     * @private
     * @param {'left'|'up'|'right'|'down'} direction The direction of the arrow key.
     * @param {Boolean} expandSelection If the current selection should be expanded.
     * @returns {Boolean} Returns `true` if key was handled.
     */

  }, {
    key: "_handleArrowKeys",
    value: function _handleArrowKeys(direction, expandSelection) {
      var model = this.editor.model;
      var selection = model.document.selection;
      var isForward = ['right', 'down'].includes(direction); // In case one or more table cells are selected (from outside),
      // move the selection to a cell adjacent to the selected table fragment.

      var selectedCells = getSelectedTableCells(selection);

      if (selectedCells.length) {
        var focusCell;

        if (expandSelection) {
          focusCell = this.editor.plugins.get('TableSelection').getFocusCell();
        } else {
          focusCell = isForward ? selectedCells[selectedCells.length - 1] : selectedCells[0];
        }

        this._navigateFromCellInDirection(focusCell, direction, expandSelection);

        return true;
      } // Abort if we're not in a table cell.


      var tableCell = selection.focus.findAncestor('tableCell');
      /* istanbul ignore if: paranoid check */

      if (!tableCell) {
        return false;
      } // Navigation is in the opposite direction than the selection direction so this is shrinking of the selection.
      // Selection for sure will not approach cell edge.


      if (expandSelection && !selection.isCollapsed && selection.isBackward == isForward) {
        return false;
      } // Let's check if the selection is at the beginning/end of the cell.


      if (this._isSelectionAtCellEdge(selection, tableCell, isForward)) {
        this._navigateFromCellInDirection(tableCell, direction, expandSelection);

        return true;
      }

      return false;
    }
    /**
     * Returns `true` if the selection is at the boundary of a table cell according to the navigation direction.
     *
     * @private
     * @param {module:engine/model/selection~Selection} selection The current selection.
     * @param {module:engine/model/element~Element} tableCell The current table cell element.
     * @param {Boolean} isForward The expected navigation direction.
     * @returns {Boolean}
     */

  }, {
    key: "_isSelectionAtCellEdge",
    value: function _isSelectionAtCellEdge(selection, tableCell, isForward) {
      var model = this.editor.model;
      var schema = this.editor.model.schema;
      var focus = isForward ? selection.getLastPosition() : selection.getFirstPosition(); // If the current limit element is not table cell we are for sure not at the cell edge.
      // Also `modifySelection` will not let us out of it.

      if (!schema.getLimitElement(focus).is('element', 'tableCell')) {
        var boundaryPosition = model.createPositionAt(tableCell, isForward ? 'end' : 0);
        return boundaryPosition.isTouching(focus);
      }

      var probe = model.createSelection(focus);
      model.modifySelection(probe, {
        direction: isForward ? 'forward' : 'backward'
      }); // If there was no change in the focus position, then it's not possible to move the selection there.

      return focus.isEqual(probe.focus);
    }
    /**
     * Moves the selection from the given table cell in the specified direction.
     *
     * @protected
     * @param {module:engine/model/element~Element} focusCell The table cell that is current multi-cell selection focus.
     * @param {'left'|'up'|'right'|'down'} direction Direction in which selection should move.
     * @param {Boolean} [expandSelection=false] If the current selection should be expanded.
     */

  }, {
    key: "_navigateFromCellInDirection",
    value: function _navigateFromCellInDirection(focusCell, direction) {
      var expandSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var model = this.editor.model;
      var table = focusCell.findAncestor('table');

      var tableMap = _toConsumableArray(new TableWalker(table, {
        includeAllSlots: true
      }));

      var _tableMap = tableMap[tableMap.length - 1],
          lastRow = _tableMap.row,
          lastColumn = _tableMap.column;
      var currentCellInfo = tableMap.find(function (_ref) {
        var cell = _ref.cell;
        return cell == focusCell;
      });
      var row = currentCellInfo.row,
          column = currentCellInfo.column;

      switch (direction) {
        case 'left':
          column--;
          break;

        case 'up':
          row--;
          break;

        case 'right':
          column += currentCellInfo.cellWidth;
          break;

        case 'down':
          row += currentCellInfo.cellHeight;
          break;
      }

      var isOutsideVertically = row < 0 || row > lastRow;
      var isBeforeFirstCell = column < 0 && row <= 0;
      var isAfterLastCell = column > lastColumn && row >= lastRow; // Note that if the table cell at the end of a row is row-spanned then isAfterLastCell will never be true.
      // However, we don't know if user was navigating on the last row or not, so let's stay in the table.

      if (isOutsideVertically || isBeforeFirstCell || isAfterLastCell) {
        model.change(function (writer) {
          writer.setSelection(writer.createRangeOn(table));
        });
        return;
      }

      if (column < 0) {
        column = expandSelection ? 0 : lastColumn;
        row--;
      } else if (column > lastColumn) {
        column = expandSelection ? lastColumn : 0;
        row++;
      }

      var cellToSelect = tableMap.find(function (cellInfo) {
        return cellInfo.row == row && cellInfo.column == column;
      }).cell;
      var isForward = ['right', 'down'].includes(direction);
      var tableSelection = this.editor.plugins.get('TableSelection');

      if (expandSelection && tableSelection.isEnabled) {
        var anchorCell = tableSelection.getAnchorCell() || focusCell;
        tableSelection.setCellSelection(anchorCell, cellToSelect);
      } else {
        var positionToSelect = model.createPositionAt(cellToSelect, isForward ? 0 : 'end');
        model.change(function (writer) {
          writer.setSelection(positionToSelect);
        });
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableKeyboard';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableSelection];
    }
  }]);

  return TableKeyboard;
}(Plugin);

export { TableKeyboard as default };